export const monthsList = [
    {
        id:1,
        number:1,
        name:'January',
        arabicName:'يناير',
    },
    {
        id:2,
        number:2,
        name:'Faburary',
        arabicName:'فبراير',
    },
    {
        id:3,
        number:3,
        name:'Mach',
        arabicName:'مارس',
    },
    {
        id:4,
        number:4,
        name:'April',
        arabicName:'ابريل',
    },
    {
        id:5,
        number:5,
        name:'May',
        arabicName:'مايو',
    },
    {
        id:6,
        number:6,
        name:'June',
        arabicName:'يونيو',
    },
    {
        id:7,
        number:7,
        name:'July',
        arabicName:'يوليو',
    },
    {
        id:8,
        number:8,
        name:'August',
        arabicName:'أوغست',
    },
    {
        id:9,
        number:9,
        name:'September',
        arabicName:'سبتمبر',
    },
    {
        id:10,
        number:10,
        name:'October',
        arabicName:'اكتوبر',
    },
    {
        id:11,
        number:11,
        name:'Novermber',
        arabicName:'نوفمبر',
    },
    {
        id:12,
        number:12,
        name:'Desember',
        arabicName:'ديسمبر',
    },
]


export const currentYear = new Date().getFullYear()
export const currentMonth = new Date().getMonth() + 1

export const yearsList = [
    {
        id:1,
        year:currentYear - 2
    },
    {
        id:2,
        year:currentYear - 1
    },
    {
        id:3,
        year:currentYear
    },
]